export enum GtagEvents {
  CARD_MODAL_OPEN = 'card_modal_open',
  CARD_MODAL_CANCEL = 'card_modal_cancel',
  CARD_MODAL_SUBMIT = 'card_modal_submit',
  CUSTOMER_MODAL_OPEN = 'customer_modal_open',
  CUSTOMER_MODAL_CANCEL = 'customer_modal_cancel',
  CUSTOMER_MODAL_SUBMIT = 'customer_modal_submit',
  TRANSACTION_SUBMIT = 'transaction_submit',
  RECURRING_CONFIGURATION_SUBMIT = 'recurring_configuration_submit',
  REFUND_SUBMIT = 'refund_submit',
  USER_LOGIN = 'user_login',
  USER_LOGOUT = 'user_logout'
}

interface GtmTrackUserSwitchAccountArgs {
  userId: string
}

export function gtmTrackUserLogin ({ userId }: GtmTrackUserSwitchAccountArgs): void {
  // @ts-expect-error datalayer thing
  window.dataLayer?.push({
    event: GtagEvents.USER_LOGIN,
    user_id: userId
  })
}

export function gtmTrackUserLogout ({ userId }: GtmTrackUserSwitchAccountArgs): void {
  // @ts-expect-error datalayer thing
  window.dataLayer?.push({
    event: GtagEvents.USER_LOGOUT,
    user_id: userId
  })
}

export function gtmTrackButtonPress (event: GtagEvents): void {
  // @ts-expect-error datalayer thing
  window.dataLayer?.push({ event })
}
